import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'nav-press-kit',
  templateUrl: './nav-press-kit.component.html',
  styleUrls: ['./nav-press-kit.component.scss']
})
export class NavPressKitComponent implements OnInit {

  links = [];

  constructor() {

    this.links = [
      { title: 'Key Findings', stlyeclass: 'icon-presentation', linkhref: '#press-information/presentation', iconname: 'fa-desktop'},
      { title: 'Press Release', stlyeclass: 'icon-press-kit', linkhref: '#press-information/press-release', iconname: 'fa-bullhorn'}     
    ];

  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/AMEX/sites/cfo-research/src/app/nav-press-kit/nav-press-kit.component.ts